import { createFileRoute, redirect } from '@tanstack/react-router'
import { organizationMembership } from '@/lib/queries/organization-memberships'
import { organization } from '@/lib/queries/organizations'
import { AdminLayout } from '@/features/admin'

/**
 * Admin Layout Route
 *
 * This route protects all /admin routes and requires the user to be a super admin.
 * Super admins can access the admin dashboard to view org/user metadata and manage the platform.
 *
 * Non-super-admins will be redirected to their first organization.
 */
export const Route = createFileRoute('/_authenticated/admin')({
  staticData: { sidebar: 'admin' },
  beforeLoad: async ({ context }) => {
    // Profile is automatically available from parent _authenticated route
    const { currentProfile } = context

    // Check super admin status
    if (!currentProfile.is_super_admin) {
      // Non-super-admins: redirect to their first org (skip index route)
      const memberships = await context.queryClient.query({
        ...organizationMembership.findManyByUser(currentProfile.id),
        staleTime: 'static',
      })

      if (memberships.length > 0) {
        const orgId = memberships[0].org_id

        // CRITICAL: Verify membership with the EXACT query org route uses
        const membership = await context.queryClient.query({
          ...organizationMembership.findOneByUserAndOrg(
            currentProfile.id,
            orgId
          ),
          staleTime: 'static',
        })

        if (membership) {
          void context.queryClient
            .query(organization.findOne(orgId))
            .catch(() => {})

          throw redirect({
            to: '/org/$orgId',
            params: { orgId },
          })
        }
      }

      // If no memberships, go to index
      throw redirect({
        to: '/',
      })
    }
  },
  component: AdminLayout,
})
